import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';

export const THEME_OPTIONS: readonly { key: 'light' | 'dark' | 'system'; icon: LucideIcon }[] = [
    { key: 'light', icon: Sun },
    { key: 'dark', icon: Moon },
    { key: 'system', icon: Monitor },
];
